App.directive('ngMultiple', function () {
  return {
      restrict: 'A',
      scope: {
          ngMultiple: '='
      },
      link: function (scope, element) {
          var unwatch = scope.$watch('ngMultiple', function (newValue) {
              if(newValue) {
                  element.attr('multiple', 'multiple');
              } else {
                  element.removeAttr('multiple');
              }
          });
      }
  };
});